export default {
  namespaced: true,
  omnicloud_fr: {
    title: "Omnicloud RF",
    provider: "Proveedor",
    provider_section: "Selecciona un proveedor",
    is_blacklist: "Lista Negra",
    master_account: {
      title: "Master Account",
      name: "Nombre",
      description: "Descripción",
      api_user: "Usuario API",
      api_password: "Contraseña API",
      api_server: "Servidor API"
    },
    watch_list: {
      title: "Lista",
      name: "Nombre",
      comment: "Comentario",
      color: "Color",
      camera_group: "Grupo de cámaras",
      master_account: "Cuenta maestra",
      enable_schedule_disable: "Habilitar pausas programadas",
      disable_schedule: "Deshabilitar programación",
      notify: "Notificar",
      acknowledge: "Acknowledge",
      face_threshold: "Umbral de rostro",
      body_threshold: "Umbral de cuerpo",
      car_threshold: "Umbral de coche",
      ignore_events: "Ignorar eventos",
      send_events_to_external_vms: "Enviar eventos a VMS externos",
      active_after: "Activo después",
      active_before: "Activo antes",
      disable_schedule_active: "Deshabilitar programación activa",
      disable_schedule_monday: "Deshabilitar programación lunes",
      disable_schedule_tuesday: "Deshabilitar programación martes",
      disable_schedule_wednesday: "Deshabilitar programación miércoles",
      disable_schedule_thursday: "Deshabilitar programación jueves",
      disable_schedule_friday: "Deshabilitar programación viernes",
      disable_schedule_saturday: "Deshabilitar programación sábado",
      disable_schedule_sunday: "Deshabilitar programación domingo",
      master_account_name: "Nombre de la cuenta maestra",
      default_configuration: "Configuración por defecto",
      title_schedule_disable: "Deshabilitar programación 00:00 - 00:00",
      info: "Información",
      reconogition_config: "Configuración de reconocimiento",
      schedule_settings: "Horarios de deshabilitación",
      type_alarm: "Tipo de alarma",
      successful_creation: "Lista de seguimiento creada correctamente",
      error_creation: "Error al crear la lista de seguimiento",
      successful_edit: "Lista de seguimiento editada correctamente",
      error_edit: "Error al editar la lista de seguimiento",
      successful_delete: "Lista de seguimiento eliminada correctamente",
      error_delete: "Error al eliminar la lista de seguimiento",
      saving_information: "Guardando información",
    },
    face: {
      image: "Imagen",
      name: "Nombre",
      active: "Activo",
      comment: "Comentario",
      master_account: "Cuenta maestra",
      watch_list: "Lista de vigilancia",
      created_at: "Fecha de creación",
      updated_at: "Fecha de actualización",
      title: "Rostros",
      features: "Características",
      already_face_added: "Rostro ya registrado",
      face_added_label: "Registrado",
      success_adding: "Rostro añadido correctamente",
      success_updating: "Rostro actualizado correctamente",
      error_saving: "Error al guardar la información",
      success_delete: "Rostro eliminado correctamente",
    },
    camera: {
      title: "Cámaras",
      name: "Nombre",
      active: "Activo",
      comment: "Comentario",
      camera_group: "Grupo de cámaras",
      created_at: "Fecha de creación",
      updated_at: "Fecha de actualización",
      refresh: "Refrescar",
      camera: "Cámara",
      status: "Estado",
    },
    face_search: {
      title: "Búsqueda de Rostro",
      search: "Buscar",
      change_search: "Cambiar búsqueda",
      no_results_found: "No se encontraron resultados",
      delete_image: "Eliminar imagen",
      full_image: "Imagen completa",
    }
  }
};
